/* @ngInject */
const go = (
  $state,
  wagonLocal,
  routes
) => {
  const self = {}

  self.consult = (_wagon, _id) => {
    const id = _wagon || _id
    wagonLocal.saveCurrentId(id)
    $state.go(routes.consult.wagon.details.path)
  }

  self.edit = (_wagon) => {
    wagonLocal.saveCurrentId(_wagon)
    $state.go(routes.consult.wagon.edit.path)
  }

  return self
}

export default go



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/services/go.service.js